import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { sizes } from '@twisto/icons'
import { borderRadius, breakpoint, size, transitions } from '@twisto/styles'

export const navigation = css`
  position: relative;
  padding: ${size[20]} ${size[24]};

  ${breakpoint.up('sm')} {
    padding: ${size[24]};
  }
`

export const separator = (theme: Theme) => css`
  border-bottom: 1px solid ${theme.palette.neutral[200]};
`

export const backIcon = (theme: Theme) => css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${size[32]};
  height: ${size[32]};
  padding: 0;
  background-color: ${theme.palette.neutral[200]};
  border-radius: ${borderRadius.circle};
  transition: background-color ${transitions.default};
  ${sizes[18]};

  ${breakpoint.up('sm')} {
    width: ${size[40]};
    height: ${size[40]};
    ${sizes[24]};
  }

  path {
    fill: ${theme.palette.neutral[800]};
    transition: fill ${transitions.default};
  }
`

export const backButton = css`
  margin-right: ${size[16]};
`
export const adornment = css`
  flex-grow: 1;
  width: auto;
`
